export default "__VITE_ASSET__cb085350__"